<div class="username-selector-switch">
  <p>Register with Mobile Number</p>
  <div class="switch tiny">
    <input
      class="switch-input"
      id="tinySwitch"
      type="checkbox"
      name="exampleSwitch"
      #switch
      (click)="changeInput(switch.checked)"
      />
      <label class="switch-paddle" for="tinySwitch">
        <span class="show-for-sr">Tiny Sandwiches Enabled</span>
      </label>
    </div>
  </div>

  <form>
    <div class="input-block">
      <label
        >{{ isEmail ? 'Email' : 'Phone Number' }}

        @if (isEmail) {
          <input
            [formControl]="formControlEmail"
            type="email"
            placeholder="Email Address"
            />
        }

        @if (!isEmail) {
          <input
            [formControl]="formControlPhone"
            type="text"
            placeholder="Phone Number"
            />
        }

        @if (
          isEmail &&
          formControlEmail.invalid &&
          (formControlEmail.dirty || formControlEmail.touched)
          ) {
          <div
            class="error-message"
            >
            @if (formControlEmail.hasError('required')) {
              <div>
                {{ 'Email is required' }}
              </div>
            }
            @if (formControlEmail.hasError('pattern')) {
              <div>
                {{ 'Invalid email address' }}
              </div>
            }
          </div>
        }

        @if (
          !isEmail &&
          formControlPhone.invalid &&
          (formControlPhone.dirty || formControlPhone.touched)
          ) {
          <div
            class="error-message"
            >
            @if (formControlPhone.hasError('required')) {
              <div>
                {{ 'Phone number is required' }}
              </div>
            }
            @if (formControlPhone.hasError('pattern')) {
              <div>
                {{ 'Invalid phone number' }}
              </div>
            }
          </div>
        }
      </label>
    </div>
  </form>
